<template>
  <div :menu-fix="true">
    <div class="wrapper">
      <breadcrumb :crumbs="['财务结账']">
        <el-button
          v-if="Permit.canActionsChargeEdition('reportMonthSettlement')"
          type="defalut"
          size="mini"
          @click="getYears"
          class="mgb10"
        >
          刷新
        </el-button>
        <el-button
          type="success"
          size="mini"
          v-if="Permit.canActionsChargeEdition('reportMonthSettlement')"
          @click="reportMonthSettlement"
          >{{ $t("action.reportMonthSettlement") }}</el-button
        >
      </breadcrumb>
    </div>
    <div
      class="wrapper table-area"
      v-if="Permit.canActionsChargeEdition('reportMonthSettlement')"
    >
      <el-tabs
        v-if="allYears.length != 0"
        v-model="selectedYear"
        type="card"
        @tab-click="getYearData"
        class="mgb20"
      >
        <el-tab-pane
          v-for="(allYear, index) in allYears"
          :key="index"
          :label="allYear"
          :name="allYear"
        >
          <div>
            <div v-if="trendChartLoading == true" class="noData">
              <i class="el-icon-loading"></i>
            </div>
            <el-row v-else>
              <el-col :span="12">
                <ve-line
                  :data="theadData"
                  :settings="chartSettings"
                  :extend="extend"
                ></ve-line>
              </el-col>
              <el-col :span="12">
                <ve-histogram
                  :data="theadData2"
                  :settings="chartSettings2"
                ></ve-histogram>
              </el-col>
            </el-row>
          </div>
          <vxe-table
            :data="yearTableRecords"
            :loading="loading"
            id="yearRecordsTable"
            row-id="id"
            ref="recordsTable"
            class="recordsTable"
            size="mini"
            resizable
            round
            auto-resize
            highlight-hover-row
            :scroll-y="{ enabled: false }"
          >
            <vxe-table-column
              field="settleAt"
              :title="$t('salesTarget.month')"
              min-width="100"
            >
              <template v-slot="{ row }">
                {{ Util.monthNumToCN(row.settleAt.slice(5, 7)) }}
              </template>
            </vxe-table-column>
            <vxe-table-column
              field="amounts"
              :title="$t('bargain.amount')"
              min-width="100"
            >
              <template v-slot="{ row }">
                <div
                  v-for="(amount, index) of row.amounts"
                  :key="index"
                  class="blue cursor-pointer"
                  @click="
                    $router.push(
                      '/fnReport/fn-reports/reports/cost-profit?settleAt=' +
                        row.settleAt
                    )
                  "
                >
                  {{ amount.symbol || amount.currency }}{{ amount.amount }}
                </div>
              </template>
            </vxe-table-column>

            <vxe-table-column
              field="productCost"
              :title="$t('monthSettlement.productCost')"
              min-width="80"
            >
              <template v-slot="{ row }">
                {{ row.productCost | currency }}
              </template>
            </vxe-table-column>
            <vxe-table-column
              field="deliverCost"
              :title="$t('monthSettlement.deliverCost')"
              min-width="80"
            >
              <template v-slot="{ row }">
                {{ row.deliverCost | currency }}
              </template>
            </vxe-table-column>
            <vxe-table-colgroup :title="$t('order.return')">
              <vxe-table-column
                field="returnAmounts"
                :title="$t('monthSettlement.returnAmount')"
                min-width="100"
              >
                <template v-slot="{ row }">
                  <div
                    v-for="(returnAmount, index) of row.returnAmounts"
                    :key="index"
                    class="blue cursor-pointer"
                    @click="
                      $router.push(
                        '/fnReport/fn-reports/reports/return-detail?settleAt=' +
                          row.settleAt
                      )
                    "
                  >
                    {{ returnAmount.symbol || returnAmount.currency
                    }}{{ returnAmount.returnAmount }}
                  </div>
                </template>
              </vxe-table-column>
              <vxe-table-column
                field="returnProductCost"
                :title="$t('monthSettlement.returnProductCost')"
                min-width="80"
              >
                <template v-slot="{ row }">
                  {{ row.returnProductCost | currency }}
                </template>
              </vxe-table-column>
            </vxe-table-colgroup>
            <vxe-table-column
              field="payAmounts"
              :title="$t('monthSettlement.payAmount')"
              min-width="80"
            >
              <template v-slot="{ row }">
                <div
                  v-for="(payAmount, index) of row.payAmounts"
                  :key="index"
                  class="blue cursor-pointer"
                  @click="
                    $router.push(
                      '/fnReport/fn-reports/reports/payment-detail?settleAt=' +
                        row.settleAt
                    )
                  "
                >
                  {{ payAmount.symbol || payAmount.currency
                  }}{{ payAmount.payAmount }}
                </div>
              </template>
            </vxe-table-column>
            <vxe-table-column
              field="createAt"
              :title="$t('text.createAt')"
              min-width="110"
            />
            <vxe-table-column
              field="action"
              :title="$t('text.action')"
              width="50"
            >
              <template v-slot="{ row }">
                <el-button type="text" size="mini" @click="deleteRow(row)">{{
                  $t("text.delete")
                }}</el-button>
              </template>
            </vxe-table-column>
          </vxe-table>
        </el-tab-pane>
      </el-tabs>
      <div v-else class="noData font20">请新增月度结账</div>
    </div>
    <span v-if="Permit.canActionsChargeEdition('reportView')">
      <div class="wrapper">
        <breadcrumb :crumbs="['数据报表']"> </breadcrumb>
      </div>
      <div
        class="wrapper table-area"
        style="padding-top: 30px; padding-bottom: 20px"
      >
        <div v-for="(report, index) of reports" :key="index">
          <fieldset class="mgb15">
            <legend>{{ report.label }}</legend>
            <div>
              <el-row>
                <el-col
                  v-for="(item, idx) of report.children"
                  :key="idx"
                  :span="4"
                >
                  <router-link :to="{ path: item.path }">
                    {{ item.label }}
                  </router-link>
                </el-col>
              </el-row>
            </div>
          </fieldset>
        </div>
      </div>
    </span>

    <!-- 月度结算 -->
    <el-dialog
      :title="$t('action.reportMonthSettlement')"
      :visible.sync="reportMonthSettlementDF"
      :close-on-click-modal="false"
      width="30%"
    >
      <el-form
        ref="reportMonthSettlementObjForm"
        :model="reportMonthSettlementObj"
      >
        <div class="red strong mgb10">为保证数据准确，请务必注意：</div>
        <div class="mgb10">
          本结账按照会计准则权责发生制方法统计，所以是按照<span class="orange"
            >订单发货时间</span
          >为准统计
        </div>
        <div class="mgb10">
          产品成本：外采成本以外财账单为准（结账前请先拉外采账单），生产成本以生产价为准（结账前请先核生产价或拉生产账单），现货成本以出库时产品中心的成本价为准
        </div>
        <div class="mgb20">发货成本以发货账单为准（结账前请先拉发货账单）</div>
        <div class="mgb10">
          <el-checkbox
            v-model="reportMonthSettlementObj.confirm"
            @change="confirmChange"
          >
            已明确结账规则
          </el-checkbox>
        </div>
        <div class="center" v-if="reportMonthSettlementObj.confirm">
          <el-form-item
            :prop="'settleAt'"
            :rules="[
              {
                required: true,
                message: $t('rules.select', [$t('salesTarget.month')]),
                trigger: 'blur',
              },
            ]"
          >
            <el-date-picker
              size="small"
              style="width: 100%"
              v-model="reportMonthSettlementObj.settleAt"
              type="month"
              placeholder="选择月份"
            >
            </el-date-picker>
          </el-form-item>
          <div class="orange font10">异步统计，三分钟后刷新显示</div>
        </div>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button
          type="primary"
          plain
          :disabled="!reportMonthSettlementObj.confirm"
          :loading="reportMonthSettlementDoing"
          size="small"
          @click="reportMonthSettlementSubmit"
          >{{ $t("text.submit") }}</el-button
        >
        <el-button size="small" @click="reportMonthSettlementDF = false">{{
          $t("text.close")
        }}</el-button>
      </div>
    </el-dialog>
  </div>
</template>
<script>
import Vue from "vue";
import { page } from "@/utils/mixins.js";
import Util from "@/utils/index.js";
import reportMenu from "@/views/fnReports/reportMenu.js";
import VeLine from "v-charts/lib/line.common";
import VeHistogram from "v-charts/lib/histogram.common";

import OrderBill from "@/api/orderBill.js";

export default {
  components: { VeLine, VeHistogram },
  mixins: [page],
  data() {
    return {
      reports: reportMenu.items,
      Util: Util,
      //
      reportMonthSettlementDF: false,
      reportMonthSettlementObj: {
        confirm: false,
        settleAt: null,
      },
      reportMonthSettlementDoing: false,
      //
      allYears: [],
      yearDatas: [],
      yearTableRecords: [],
      selectedYear: null,
      //
      theadData: {
        columns: ["日期", "成本", "利润"],
        rows: [],
      },
      chartSettings: {
        area: true,
        stack: {
          销售额: ["成本", "利润"],
        },
      },
      extend: {
        series: {
          smooth: false,
        },
      },
      //
      theadData2: {
        columns: ["日期", "今年成本", "今年利润", "去年成本", "去年利润"],
        rows: [],
      },
      chartSettings2: {
        area: true,
        stack: {
          今年: ["今年成本", "今年利润"],
          去年: ["去年成本", "去年利润"],
        },
      },
      trendChartLoading: false,
    };
  },
  watch: {
    selectedYear: {
      getYearData(newValue, oldValue) {
        // this.selectedYear = newValue;
        this.getYearTableData();
        this.getYearTrendChart();
      },
    },
  },
  created() {
    const self = this;
    self.getYears();
  },
  methods: {
    getYears() {
      const self = this;
      OrderBill.allYear().then(function (res) {
        if (res.status === 200) {
          self.allYears = res.data.sort().reverse();
          if (self.allYears.length !== 0) {
            self.selectedYear = self.allYears[0];
            self.getYearData();
          }
          //
        } else {
          self.sysError();
        }
      });
    },
    getYearData() {
      this.getYearTableData();
      this.getYearTrendChart();
    },
    getYearTrendChart() {
      const self = this;
      self.trendChartLoading = true;
      OrderBill.trendChart({ year: self.selectedYear }).then(function (res) {
        if (res.status === 200) {
          self.theadData.rows = res.data.map((r) => {
            return {
              日期: Util.monthNumToCN(r.date.slice(5, 7)),
              成本: r.cost,
              // 成交额: r.amount,
              利润: r.profit,
            };
          });
          self.theadData2.rows = res.data.map((r) => {
            return {
              日期: Util.monthNumToCN(r.date.slice(5, 7)),
              今年成本: r.cost,
              // 今年成交额: r.amount,
              今年利润: r.profit,
              去年成本: r.lastCost,
              // 去年成交额: r.lastAmount,
              去年利润: r.lastProfit,
            };
          });
          self.trendChartLoading = false;
        } else {
          self.sysError();
        }
      });
    },
    getYearTableData() {
      const self = this;
      self.loadingStart();
      OrderBill.findByYear({ year: self.selectedYear }).then(function (res) {
        if (res.status === 200) {
          self.yearTableRecords = res.data;
        } else {
          self.sysError();
        }
        self.loadingEnd();
      });
    },

    // 删除
    deleteRow(row) {
      const self = this;
      if (confirm(this.$t("prompt.confirmDelete"))) {
        OrderBill.delete(row.id).then(function (res) {
          if (res.status === 200) {
            self.$message({
              message: self.$t("prompt.delSuccess"),
              type: "success",
            });
            self.getYears();
          } else {
            self.sysError();
          }
        });
      }
    },
    //
    reportMonthSettlement() {
      const self = this;
      self.reportMonthSettlementObj.confirm = false;
      self.reportMonthSettlementObj.settleAt = null;
      self.reportMonthSettlementDF = true;
    },
    confirmChange() {
      this.reportMonthSettlementObj.settleAt = null;
    },
    reportMonthSettlementSubmit() {
      const self = this;
      if (!self.reportMonthSettlementObj.confirm) {
        self.$message({
          message: "请勾选 已明确结算规则",
          type: "warning",
        });
        return;
      }

      self.$refs.reportMonthSettlementObjForm.validate((valid) => {
        if (valid) {
          self.reportMonthSettlementObj.settleAt = Util.formatDate(
            self.reportMonthSettlementObj.settleAt
          ).substring(0, 7);
          console.log("===", self.reportMonthSettlementObj);
          self.reportMonthSettlementDoing = true;
          OrderBill.create(self.reportMonthSettlementObj).then(function (res) {
            self.reportMonthSettlementDoing = false;
            self.reportMonthSettlementDF = false;
            if (res.status === 200) {
              self.$message({
                message: self.$t("prompt.settlementSuccess"),
                type: "success",
              });
            } else {
              self.sysError();
            }
          });
        } else {
          return false;
        }
      });
    },
  },
};
</script>
<style scoped>
</style>